import { RouteObject } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { LoadingSpinner } from '@/components/ui/loading-spinner';
import { ProtectedRoute } from '@/components/ProtectedRoute';

const Jobs = lazy(() => import('@/pages/staff/Jobs'));
const JobDetailsPage = lazy(() => import('@/pages/staff/JobDetailsPage'));
const JobDetailsExternalRedirectPage = lazy(
  () => import('@/pages/staff/JobDetailsExternalRedirectPage'),
);
const Finance = lazy(() => import('@/pages/staff/Finance'));
const Tutors = lazy(() => import('@/pages/staff/Tutors'));
const TutorProfilePage = lazy(() => import('@/pages/staff/TutorProfilePage'));
const Contacts = lazy(() => import('@/pages/staff/Clients'));
const Students = lazy(() => import('@/pages/staff/Students'));
const Schools = lazy(() => import('@/pages/staff/Schools'));
const StudentReports = lazy(() => import('@/pages/staff/StudentReports'));

export const staffRoutes: RouteObject[] = [
  {
    path: 'staff',
    children: [
      {
        path: 'jobs',
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<LoadingSpinner size="md" />}>
                <ProtectedRoute allowedRoles={['staff']}>
                  <Jobs />
                </ProtectedRoute>
              </Suspense>
            ),
          },
          {
            path: ':jobId',
            element: (
              <Suspense fallback={<LoadingSpinner size="md" />}>
                <ProtectedRoute allowedRoles={['staff']}>
                  <JobDetailsPage />
                </ProtectedRoute>
              </Suspense>
            ),
          },
        ],
      },
      {
        path: 'jobs/external/:externalId',
        element: (
          <Suspense fallback={<LoadingSpinner size="md" />}>
            <ProtectedRoute allowedRoles={['staff']}>
              <JobDetailsExternalRedirectPage />
            </ProtectedRoute>
          </Suspense>
        ),
      },
      {
        path: 'finance',
        children: [
          {
            path: 'billing',
            element: (
              <Suspense fallback={<LoadingSpinner size="md" />}>
                <ProtectedRoute allowedRoles={['staff']}>
                  <Finance activeTab="billing" />
                </ProtectedRoute>
              </Suspense>
            ),
          },
          {
            path: 'payments-pro',
            element: (
              <Suspense fallback={<LoadingSpinner size="md" />}>
                <ProtectedRoute allowedRoles={['staff']}>
                  <Finance activeTab="payments-pro" />
                </ProtectedRoute>
              </Suspense>
            ),
          },
          {
            path: 'payments-self-employed',
            element: (
              <Suspense fallback={<LoadingSpinner size="md" />}>
                <ProtectedRoute allowedRoles={['staff']}>
                  <Finance activeTab="payments-self-employed" />
                </ProtectedRoute>
              </Suspense>
            ),
          },
          {
            path: 'overtime',
            element: (
              <Suspense fallback={<LoadingSpinner size="md" />}>
                <ProtectedRoute allowedRoles={['staff']}>
                  <Finance activeTab="overtime" />
                </ProtectedRoute>
              </Suspense>
            ),
          },
        ],
      },
      {
        path: 'tutors',
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<LoadingSpinner size="md" />}>
                <ProtectedRoute allowedRoles={['staff']}>
                  <Tutors />
                </ProtectedRoute>
              </Suspense>
            ),
          },
          {
            path: ':tutorId',
            element: (
              <Suspense fallback={<LoadingSpinner size="md" />}>
                <ProtectedRoute allowedRoles={['staff']}>
                  <TutorProfilePage />
                </ProtectedRoute>
              </Suspense>
            ),
          },
        ],
      },
      {
        path: 'clients',
        element: (
          <Suspense fallback={<LoadingSpinner size="md" />}>
            <ProtectedRoute allowedRoles={['staff']}>
              <Contacts />
            </ProtectedRoute>
          </Suspense>
        ),
      },
      {
        path: 'students',
        element: (
          <Suspense fallback={<LoadingSpinner size="md" />}>
            <ProtectedRoute allowedRoles={['staff']}>
              <Students />
            </ProtectedRoute>
          </Suspense>
        ),
      },
      {
        path: 'schools',
        element: (
          <Suspense fallback={<LoadingSpinner size="md" />}>
            <ProtectedRoute allowedRoles={['staff']}>
              <Schools />
            </ProtectedRoute>
          </Suspense>
        ),
      },
      {
        path: 'reports',
        element: (
          <Suspense fallback={<LoadingSpinner size="md" />}>
            <ProtectedRoute allowedRoles={['staff']}>
              <StudentReports />
            </ProtectedRoute>
          </Suspense>
        ),
      },
    ],
  },
];
